import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-40c889dc"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "backstage-manage"
}, "web-ssh-terminal", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "caidan-auth"
}, "节点服务器", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "caidan-auth"
}, "节点服务器", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "toolbar"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "toolbar-open-close"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "layui-icon"
})])]), /*#__PURE__*/_createElementVNode("div", {
  class: "toolbar-static"
})], -1));

import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { Location, Document, Menu as IconMenu, Setting } from '@element-plus/icons-vue';
import variables from "@/assets/styles/variables.scss";
import store from "@/store/index.ts";
import { ElMessage } from 'element-plus';
export default {
  __name: 'index',

  setup(__props) {
    const asideWidth = computed(() => {
      return "210";
    }); // // 保存信息和url到缓存里面
    // const goUrl = (authName, authName2, url) => {
    //     store.commit("openNames", authName);
    //     store.commit("activeName", authName2);
    //     sessionStorage.setItem(`url`,`${url}`)
    //     activePath.value = sessionStorage.getItem(`url`)   
    // }

    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");

      const _component_el_sub_menu = _resolveComponent("el-sub-menu");

      const _component_el_menu = _resolveComponent("el-menu");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_aside = _resolveComponent("el-aside");

      const _component_el_header = _resolveComponent("el-header");

      const _component_router_view = _resolveComponent("router-view");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createBlock(_component_el_container, {
        class: "app-wrapper"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: _unref(asideWidth),
          class: "sidebar-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            style: {
              "height": "'100%'"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_menu, {
              "active-text-color": "#ffd04b",
              "background-color": "#20222A",
              class: "el-menu-vertical-demo",
              "default-active": _ctx.activePath,
              "text-color": "#fff",
              "unique-opened": "",
              router: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_menu_item, {
                index: "board",
                onClick: _cache[0] || (_cache[0] = $event => _ctx.goUrl('web-ssh-terminal', '', 'board')),
                style: {
                  "height": "50px !important",
                  "background-color": "var(--el-menu-hover-bg-color)  !important"
                }
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              }), _createVNode(_component_el_sub_menu, null, {
                title: _withCtx(() => [_hoisted_2]),
                default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
                  default: _withCtx(() => [_hoisted_3]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["default-active"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["width"]), _createVNode(_component_el_container, {
          class: "container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, {
            style: {
              "font-size": "16px",
              "background-color": "#ffffff"
            }
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }), _createVNode(_component_el_main, {
            style: {
              "background-color": "#f2f2f2"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }

};